import Box from "@mui/material/Box";
import { AlertCircle, Check, Clock } from "lucide-react";
import { logoPlatform } from "../../utils/string";

const DEFAULT_SIZE = 24;
const BORDER_RADIUS = "22%";
const CHECK_BORDER = "#fbfcfd";
const REFERENCE_SIZE = 22;

const STATUS_BADGES = {
  published: { backgroundColor: "#29a66d", Icon: Check },
  scheduled: { backgroundColor: "#d97706", Icon: Clock },
  failed: { backgroundColor: "#dc2626", Icon: AlertCircle },
};

const PlatformLogo = ({
  platform,
  width,
  height,
  showCheck = false,
  statusIndicator = null,
  alt = "",
  sx = {},
  ...rest
}) => {
  const resolvedWidth = width ?? height ?? DEFAULT_SIZE;
  const resolvedHeight = height ?? width ?? DEFAULT_SIZE;
  const logoSrc = logoPlatform(platform);
  const resolvedStatus =
    statusIndicator || (showCheck ? "published" : null);
  const badge = resolvedStatus ? STATUS_BADGES[resolvedStatus] : null;
  const StatusIcon = badge?.Icon;

  if (!logoSrc) return null;

  const minSize = Math.min(resolvedWidth, resolvedHeight);
  const badgeSize = Math.max(10, Math.round((minSize * 12) / REFERENCE_SIZE));
  const iconSize = Math.max(6, Math.round((minSize * 8) / REFERENCE_SIZE));
  const badgeOffset = -Math.max(3, Math.round((minSize * 4) / REFERENCE_SIZE));

  return (
    <Box
      component="span"
      {...rest}
      sx={{
        position: "relative",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        width: resolvedWidth,
        height: resolvedHeight,
        overflow: "visible",
        ...sx,
      }}
    >
      <Box
        component="img"
        src={logoSrc}
        alt={alt}
        sx={{
          width: "100%",
          height: "100%",
          objectFit: "contain",
          objectPosition: "center",
          display: "block",
          borderRadius: BORDER_RADIUS,
        }}
      />
      {badge ? (
        <Box
          component="span"
          sx={{
            position: "absolute",
            right: badgeOffset,
            bottom: badgeOffset,
            width: badgeSize,
            height: badgeSize,
            display: "grid",
            placeItems: "center",
            border: `2px solid ${CHECK_BORDER}`,
            borderRadius: "50%",
            backgroundColor: badge.backgroundColor,
            color: "#fff",
          }}
        >
          {StatusIcon ? <StatusIcon size={iconSize} strokeWidth={3} /> : null}
        </Box>
      ) : null}
    </Box>
  );
};

export default PlatformLogo;
